import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import router from './router'
import store from './store'
import { flat2treeHelp } from './utils/flat2tree'
import { uniqueArrayData } from './utils/object'
import { getUserInfo } from '@/api/mange/user'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/reset_pwd'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()
  const identity = to.query?.identity
  if (identity) {
    //重新获取账号权限
    await handleIdentityLogin(identity)
    delete to.query.identity
  }

  // determine whether the user has logged in
  const hasToken = store.getters['user/isLogin']
  // const hasToken = "fake token";
  if (!hasToken) {
    // 未登录
    if (to.meta.requireLogin) {
      return redirectToLogin(to, next)
    }
    NProgress.done()
    return next()
  }
  // 已登录
  if (to.path === '/login') {
    // if is logged in, redirect to the home page
    NProgress.done()
    return next()
  }
  const hasGetRouter = store.state.user.menuRouteLoaded
  if (hasGetRouter) {
    console.log('动态菜单和路由已经存在.')
    return next()
  }

  try {
    /**
     * 从后端动态读取路由 start
     */
    const { menuAuth, allAuth } = getUserMenuAuth()
    if (!menuAuth.length) {
      store.dispatch('user/setMenuRouteLoaded', true)
      return next()
    }

    const rdata = JSON.parse(JSON.stringify(menuAuth))
    const rewriteRoutes = addDynamicMenuAndRoutes(rdata) // 将后端返回的路由转换为组件
    // 添加动态路由
    if (rewriteRoutes.length > 0) {
      rewriteRoutes.forEach((r) => {
        router.addRoute(r.parenName, r)
      })
    }
    // 保存加载状态
    store.dispatch('user/setMenuRouteLoaded', true)
    const setNavTree = flat2treeHelp(rewriteRoutes)
    // 保存菜单树
    store.dispatch('user/setNavTree', JSON.stringify(setNavTree))
    const buttonAuthLabel = allAuth.map((item) => item.code)
    store.dispatch('user/setButtonRoles', JSON.stringify(buttonAuthLabel))
    /**
     * 从后端动态读取路由 end
     */
    // hack method to ensure that addRoutes is complete
    // set the replace: true, so the navigation will not leave a history record
    // 首次登录（没有 from.name），并且当前 path 是根路径或 /login
    if (!from.name && (to.path === '/home' || to.path === '/' || to.path === '/login')) {
      const firstMenu = getFirstMenuFromAuth(setNavTree)
      return next({ path: firstMenu?.path || '/home', replace: true })
    }
    return next({ ...to, replace: true })
  } catch (error) {
    // remove token and go to login page to re-login
    await store.dispatch('user/logout')
    // Message.error(error || "Has Error");
    next(`/login?redirect=${to.path}`)
    NProgress.done()
  }
})

// 处理 identity 登录
async function handleIdentityLogin(identity) {
  await store.dispatch('user/login', { token: `Bearer ${identity}` })
  store.dispatch('user/setMenuRouteLoaded', false)
  const { data } = await getUserInfo()
  store.dispatch('user/update', { ...data })
}

function redirectToLogin(to, next) {
  NProgress.done()
  next(`/login?redirect=${to.path}`)
}
let firstMenu = ''
// 从 menuAuth 获取第一个权限菜单
function getFirstMenuFromAuth(menus) {
  if (!Array.isArray(menus) || menus.length === 0) return null

  for (const menu of menus) {
    if (menu.path && menu.path !== '/' && menu.type !== 'CHILDPAGE') {
      firstMenu = menu
    }
    if (Array.isArray(menu.children) && menu.children.length > 0) {
      firstMenu = getFirstMenuFromAuth(menu.children)
      if (firstMenu) return firstMenu
    }
    return firstMenu
  }
}

/**
 *后端动态读取路由start
 */
function addDynamicMenuAndRoutes(routers) {
  if (!routers.length) return []
  // 遍历后台传来的路由字符串，转换为组件对象
  return routers.filter((router) => {
    // router.name = router.name
    router.path = '/' + router.path
    router.meta = {
      icon: router.icon,
      title: router.name,
      hideMenu: router.type === 'CHILDPAGE',
      requireLogin: true
    }
    let [, parenName] = router.path.split('/')
    router.parenName = parenName
    router['component'] = loadView(router.path)
    return true
  })
}
/*
 * 获取账号权限
 * type
 *** ROOTMENU: 一级菜单  比如:我的项目、系统配置、行动工单、
 *** CHILDPAGE：不在导航栏显示的二级菜单，问卷编辑页、问卷逻辑页、外观页
 *** LEAFMENU: 二级菜单 比如：用户列表、角色管理
 *** BUTTON：按钮
 */
function getUserMenuAuth() {
  const rolesData = JSON.parse(store.state.user.userInfo).roles || []

  let allAuth = []
  rolesData.map((item) => {
    item.menuAuth.map((menu) => allAuth.push(menu))
  })
  allAuth = uniqueArrayData(allAuth) //去重
  allAuth.sort((a, b) => a.id - b.id) // 按id排序
  return {
    menuAuth: allAuth.filter((item) => item.type !== 'BUTTON'),
    allAuth
  }
}

export const loadView = (view) => {
  return (resolve) => require([`@/views${view}`], resolve)
}
window.router = router

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
